import styled from "styled-components";
import { Flex } from "uikit";

const Root = styled(Flex)`
	cursor: pointer;
`;

export default Root;
